const buildUrl = _ref => {
  let {
    url,
    params
  } = _ref;
  const baseUrl = window.location.origin;
  const urlWithParams = new URL(url, baseUrl);
  if (params) {
    const filteredParams = Object.entries(params).filter(_ref2 => {
      let [_, value] = _ref2;
      return !!value;
    });
    filteredParams.forEach(_ref3 => {
      let [key, value] = _ref3;
      urlWithParams.searchParams.set(key, (value == null ? void 0 : value.toString()) ?? '');
    });
  }
  return urlWithParams.toString();
};
const replaceSearchParam = (key, value) => {
  const url = new URL(window.location.href);
  if (!value) {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }
  window.history.replaceState({}, '', url.toString());
};
export const UrlUtils = {
  buildUrl,
  replaceSearchParam
};
//# sourceMappingURL=url-utils.js.map